<template>
    <div class="bg-gray-200 pt-4 pb-32 min-h-screen relative">
        <loading :active.sync="loading"></loading>
        <div v-if="filterPanelShown" class="absolute inset-0 bg-gray-200 pt-12" style="z-index: 999999">
            <div class="flex justify-left mb-4 px-4">
                <button
                        @click="hideFilterPanel"
                        class="text-azuloscuro px-4 pt-2 pb-3 rounded-full hover:bg-azuloscuro hover:text-white mr-4 mb-2"
                >
                    <Zondicon icon="arrow-thin-left"
                              class="fill-current inline-block h-4 line"/>
                </button>
                <div class="text-azuloscuro text-xl font-semibold text-center w-full pt-1">Filtrar</div>
            </div>

            <div class="mb-4 px-4">
                <h2 class="text-azuloscuro text-xl">Categoría</h2>
            </div>

            <div class="mb-4 px-4">
                <CategoryButton
                        v-for="(value, key) in categories"
                        :key="key"
                        :category="value"
                        v-model="categoryFilter[key]"
                />
            </div>

            <div class="mb-4 px-4">
                <h2 class="text-azuloscuro text-xl">Tipo de Archivo</h2>
            </div>

            <div class="mb-4 px-4">
                <FileTypeButton type="video" v-model="typeFilter['0']"/>
                <FileTypeButton type="pdf" v-model="typeFilter['1']"/>
                <FileTypeButton type="audio" v-model="typeFilter['2']"/>
                <FileTypeButton type="text" v-model="typeFilter['3']"/>
                <FileTypeButton type="image" v-model="typeFilter['4']"/>
            </div>

            <div class="mb-4 px-4">
                <div class="mt-20">
                    <button
                            @click="hideFilterPanel"
                            class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                            type="button"
                    >Filtrar
                    </button>
                </div>

                <div class="mt-5 text-center">
                    <a
                            @click="clearFilter"
                            class="inline-block self-center text-sm text-blue-500 hover:text-blue-800"
                    >Eliminar filtros</a>
                </div>
            </div>
        </div>
        <div v-else>
            <h1 class="text-azuloscuro text-xl font-semibold p-4 mb-4">Pills realizadas</h1>

            <div class="mb-4 px-4">
                <div class="flex justify-left bg-white rounded-lg px-4 py-3 border border-gray-300">
                    <img src="@/assets/images/Search.svg" class="w-1/7 mr-3"/>
                    <input
                            v-model="searchText"
                            class="w-full text-azuloscuro focus:outline-none"
                            placeholder="Busca aquí tu Pill"
                    />
                </div>
            </div>

            <div class="mb-4 px-4">
                <div class="flex justify-between">
                    <button
                            @click="toggleFilterByWishlist"
                            type="button"
                            class="bg-white w-1/8 rounded-lg px-4 py-2 border border-gray-300 mr-4"
                    >
                        <img v-if="filterByWishlist" src="@/assets/images/Favoritos.svg" class="w-6 h-6"/>
                        <img v-else src="@/assets/images/heart.svg" class="w-6 h-6"/>
                    </button>

                    <button
                            type="button"
                            class="flex flex-row bg-white rounded-lg px-4 py-2 border border-gray-300 mr-4"
                            @click="abrirModalOrden"
                    >
                        <img src="@/assets/images/ordenar.svg" class="inline-block w-4 h-4 mt-1"/>
                        <img src="@/assets/images/assets.svg"
                             class="inline-block w-3 h-4 ml-3 mt-1 mr-4"/>
                    </button>

                    <button
                            type="button"
                            class="flex flex-row bg-azuloscuro text-white w-full rounded-lg px-4 py-2 border border-gray-300"
                            @click="showFilterPanel"
                    >
                        <img src="@/assets/images/Filter.svg" class="w-3 h-4 mt-1 mr-4"/>
                        <span class="w-full">Filtrar</span>
                        <img src="@/assets/images/assets2.svg" class="ml-4 mt-2"/>
                    </button>
                </div>
            </div>
            <div class="relative mb-4 px-4 cursor-pointer">
                <div
                        v-if="modal_orden_mostrado == true"
                        class="absolute bg-white inline-block px-5 py-6 shadow rounded-lg"
                        style="top: -14px;"
                >
                    <h3 class="text-azuloscuro text-lg font-semibold text-center mb-4">Ordenar
                        por</h3>
                    <div class="text-center">
                        <button
                                class="text-sm px-3 py-2 rounded-full border border-gray-300 hover:bg-azuloscuro hover:text-white mr-4 mb-2"
                                :class="(sort === 'ASC') ? ['bg-azuloscuro','text-white']:['bg-white','text-azuloscuro']"
                                @click="cerrarModalOrden('ASC')"
                        >Más antiguos primero
                        </button>
                    </div>

                    <div class="text-center">
                        <button
                                class="text-sm px-3 py-2 rounded-full border border-gray-300 hover:bg-azuloscuro hover:text-white mr-4 mb-2"
                                :class="(sort === 'DESC') ? ['bg-azuloscuro','text-white']:['bg-white','text-azuloscuro']"
                                @click="cerrarModalOrden('DESC')"
                        >Más recientes primero
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="completedPills.length">
                <div>
                    <div v-if="pillsBySearch.length">
                        <div
                                v-for="(i, idx) in pillsBySearch"
                                v-bind:key="idx"
                                @click="abrirPill(i.pill.contentType, i, idx)"
                                class="mb-4 px-4 cursor-pointer"
                        >
                            <Pill :pill="i" :isInWishlist="isInWishlist(i.pill)"/>
                        </div>
                    </div>
                    <div
                            v-else
                            class="mb-4 px-4"
                    >No se ha encontrado ninguna Pill bajo esos criterios de búsqueda.
                    </div>
                </div>
            </div>
            <div v-else class="mb-4 px-4">No tienes Pills completadas</div>
        </div>
        <Menu current="search"/>
    </div>
</template>

<script>
    import Utilities from "@/plugins/Utilities.js";
    import Zondicon from "vue-zondicons";
    import Menu from "@/components/Menu";
    import pills from "@/plugins/api/pills/pills";
    import Pill from "@/components/Pill";
    import CategoryButton from "@/components/CategoryButton";
    import FileTypeButton from "@/components/FileTypeButton";
    import wishlist from "../plugins/api/wishlist/wishlist";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import setTitle from "../plugins/title";

    const DEFAULT_TYPE_FILTER = {
        '0': true,
        '1': true,
        '2': true,
        '3': true,
        '4': true
    }

    const Search = {
        name: "Search",
        layout: "layout",
        components: {
            Menu,
            Zondicon,
            Pill,
            CategoryButton,
            FileTypeButton,
            Loading
        },
        data: function () {
            return {
                completedPills: [],
                filterPanelShown: false,
                typeFilter: {},
                categoryFilter: {},
                searchText: "",
                categories: {},
                modal_orden_mostrado: false,
                sort: 'ASC',
                wishlist: [],
                filterByWishlist: false,
                loading: false
            };
        },
        beforeMount: function () {
            if (!Utilities.isLogged()) {
                this.$router.push({name: "login"});
            }
            this.loadPills();
            this.loadWishList();
            this.loadCategories();
        },
        methods: {
            async loadPills() {
                this.loading = true
                try {
                    this.completedPills = (await pills.getCompletedPills()).data["hydra:member"]
                    this.loading = false
                } catch (e) {
                    console.log(e)
                    this.loading = false
                }
            },
            async loadWishList() {
                wishlist.getWishList().then(response => {
                    this.wishlist = response.data["hydra:member"]
                })
            },
            async loadCategories () {
                pills.getCategories().then(response => {
                    this.categories = response.data.categories
                })
            },
            isInWishlist(pill) {
                return this.wishlistIds.includes(pill['@id'])
            },
            showFilterPanel: function () {
                this.filterPanelShown = true
            },
            hideFilterPanel: function () {
                this.filterPanelShown = false
            },
            clearFilter() {
                this.categoryFilter = {}
                this.typeFilter = {}
                this.filterPanelShown = false
            },
            abrirModalOrden: function () {
                if (this.modal_orden_mostrado) {
                    this.modal_orden_mostrado = false;
                } else {
                    this.modal_orden_mostrado = true;
                }
            },
            cerrarModalOrden: function (order) {
              this.modal_orden_mostrado = false;
              this.sort = order
            },
            abrirPill: function (tipo, i, idx) {
                localStorage.setItem('last_pill', JSON.stringify({ i, idx }))
                if (tipo == "0") {
                    this.$router.push({name: "pills_video", params: {i, idx}});
                }

                if (tipo == "1") {
                    this.$router.push({name: "pills_pdf", params: {i, idx}});
                }

                if (tipo == "2") {
                    this.$router.push({name: "pills_audio", params: {i, idx}});
                }

                if (tipo == "3") {
                    this.$router.push({name: "pills_text", params: {i, idx}});
                }

                if (tipo == "4") {
                    this.$router.push({name: "pills_image", params: {i, idx}});
                }
            },
            toggleFilterByWishlist() {
                this.filterByWishlist = !this.filterByWishlist
            }
        },
        filters: {
            date: function (value) {
                return new Date(value).toLocaleDateString("es-ES");
            }
        },
        computed: {
            pillsBySearch: function () {
              return this.completedPills
                      .filter(aP => {
                        const pill = aP.pill
                        const text = [pill.name, pill.description, pill.contentTitle, pill.content, pill.metadata].join(' ').toLowerCase();
                        return text.indexOf(this.searchText.toLowerCase()) !== -1
                      })
                      .filter(aP => Object.entries(this.categoryFilter).filter(([k, v]) => v).length > 0 ? Object.entries(this.categoryFilter).filter(([key, value]) => value).map(([key, value]) => key).includes(aP.pill.category) : true)
                      .filter(aP => Object.entries(this.typeFilter).filter(([k, v]) => v).length > 0 ? Object.entries(this.typeFilter).filter(([key, value]) => value).map(([key, value]) => key).includes(aP.pill.contentType) : true)
                      .filter(aP => !this.filterByWishlist ? true : this.isInWishlist(aP.pill))
                      .sort((a, b) => a.startDate < b.startDate ? (this.sort === 'DESC' ? 1 : -1) : (this.sort === 'ASC' ? 1 : -1))
            },
            wishlistIds: function () {
                return this.wishlist.map(w => w.pill)
            }
        },
        created () {
            setTitle('Búsqueda')
        }
    };
    export default Search;
</script>
